import { render, staticRenderFns } from "./referral-timeline.vue?vue&type=template&id=3b50e50a&scoped=true&"
import script from "./referral-timeline.vue?vue&type=script&lang=js&"
export * from "./referral-timeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b50e50a",
  null
  
)

export default component.exports